module.exports = __webpack_public_path__ + "media/images/costumes/top/swiper-dress-3-6ee6b9c81f9c7edc48d9c1cb6ee2ed87.jpg";